/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer'
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from '../../../redux/apis/authAPIs';
import { logout } from '../../../redux/features/auth-slice';
import { IdleTimeoutModal } from '../modals';

const ActivityDetection = () => {
	const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn)
	const isSystemPortal = useSelector((state: any) => state.auth.isSystemUser)
	const tokenValidTime = useSelector((state: any) => state.auth.tokenValidTime)
	const [showInactive, setShowInactive] = useState(false);
	const dispatch = useDispatch();
	// const timeout = 5000; // 5 Seconds
	const timeout = ((tokenValidTime < 1 || !tokenValidTime || isNaN(tokenValidTime)) ? 1 : tokenValidTime) * 60 * 60 * 1000; // 15 Minutes

	const onIdle: any = async () => {
		// console.log('user is idle too long', 7979, isSystemPortal, isLoggedIn, tokenValidTime);
		if (isLoggedIn && isSystemPortal) {
			// await dispatch(logoutAction());
			// dispatch(logout());
			// setShowInactive(true);
		}
	}

	const onActive = (event: any) => {
		// console.log('user is active', event)
	}

	const onAction = (event: any) => {
		// console.log('onAction', idleTimer.getRemainingTime())
	}

	const onClose = () => {
		setShowInactive(false);
	}

	const idleTimer = useIdleTimer({
		timeout: timeout,
		onIdle,
		onActive,
		onAction,
		debounce: 500,
		name: 'user-activity-timer',
	});

	return (
		<>
			<IdleTimeoutModal
				isVisible={showInactive}
				onConfirm={onClose}
				titleMessage={'idle_timeout_message'}
				title={'idle_timeout_title'}
			/>
		</>
	);
};

export default ActivityDetection;